import createRequestSlice, { requestInitialState } from 'redux/request/reducer';

export const PREFIX = 'filmsAuto';

export const initialState = {
  ...requestInitialState,
  data: [],
};

const filmsAutoSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    fetch(state, { payload }) {
      return {
        ...state,
        data: [...payload],
      };
    },
  },
});

export const actions = { ...filmsAutoSlice.actions };
export const requests = { ...filmsAutoSlice.requests };

export default filmsAutoSlice.reducer;
